import lang from 'public/locales/en-US.json'
import { TFunction } from 'react-i18next'

export const plansNamesById: Record<number, string> = {
  6: 'Freemium',
  7: 'Pro',
  8: 'Business',
  10: 'Starter',
}

export const getBillingString = (periodUnit: string) =>
  periodUnit === 'year' ? 'Billing Annually' : 'Billing Monthly'

export const formatPrice = (price: number) => {
  // we always round up to next int
  const priceInt = Math.ceil(price / 100)
  return `$${priceInt.toLocaleString('en-US')}`
}

export const computeNextBillingInfo = ({
  trialExpiration,
  defaultTrialDays,
  userCanGoInTrial,
  t,
}: {
  trialExpiration?: string
  defaultTrialDays: number
  userIsCurrentyInTrial: boolean
  userCanGoInTrial: boolean
  t: TFunction<'all', undefined>
}): {
  // nextBillingDate?: string
  // buttonLabel: string
  trialDaysAvailable: number
} => {
  const today = new Date()

  // ('COMPUTE NEXT BILLING INFO START')

  const trialDateExpirationDate = trialExpiration
    ? new Date(trialExpiration)
    : undefined

  const dateDelta = trialDateExpirationDate
    ? trialDateExpirationDate.getTime() - today.getTime()
    : null
  const daysLeft = dateDelta
    ? Math.ceil(dateDelta / (1000 * 3600 * 24))
    : defaultTrialDays

  /* console.log(
    'trialDateExpirationDate = ' +
      trialDateExpirationDate +
      ' userIsCurrentyInTrial = ' +
      userIsCurrentyInTrial +
      ' userCanGoInTrial = ' +
      userCanGoInTrial
  ) */

  /*
  const userAvailableTrialDays =
    trialDateExpirationDate && userIsCurrentyInTrial
      ? daysLeft
      : userCanGoInTrial
      ? defaultTrialDays
      : 0
  
  const userAvailableTrialDays = userCanGoInTrial
    ? trialDateExpirationDate && userIsCurrentyInTrial
      ? daysLeft
      : defaultTrialDays
    : 0

  // console.log('userAvailableTrialDays = ' + userAvailableTrialDays)
  /*
  const nextBillingDateTimestamp = userAvailableTrialDays
    ? new Date().setDate(today.getDate() + userAvailableTrialDays)
    : undefined

  const nextBillingDate = nextBillingDateTimestamp
    ? new Date(nextBillingDateTimestamp).toLocaleDateString()
    : undefined
  const buttonLabel =
    userAvailableTrialDays && userIsCurrentyInTrial
      ? t('billing.checkout.ctaPayButStillTrial', {
          daysLeft: userAvailableTrialDays,
        })
      : userAvailableTrialDays
      ? t('billing.checkout.ctaPayStartTrial', {
          daysLeft: userAvailableTrialDays,
        })
      : t('billing.checkout.ctaPayWithoutTrial')
  */

  const trialDaysAvailable = userCanGoInTrial ? daysLeft : 0

  /* console.log(
    'buttonLabel = ' +
      buttonLabel +
      ' trialDaysAvailable = ' +
      trialDaysAvailable
  ) */

  return {
    // nextBillingDate,
    // buttonLabel,
    trialDaysAvailable,
  }
}

export const computePlanDescription = ({
  planName,
  bridgesLimit,
  mtuLimit,
  hasTrial,
}: {
  planName: string
  bridgesLimit: number
  mtuLimit: number
  hasTrial: boolean
}) => {
  return ` ${planName} Plan ${
    hasTrial ? 'Free Trial' : ''
  } with ${bridgesLimit} Bridges and ${mtuLimit.toLocaleString('en-US')} ${
    lang.billing.pricing.mtuOption
  }`
}
